/**
 * Helper functions for Power BI Reports
 */

/**
 * Build embed payload for Power BI report
 * @param {Object} report - Report object
 * @param {Object} empInfo - Employee info from localStorage
 * @param {Object} biEmpInfo - Power BI employee info from localStorage
 * @returns {Object} Embed payload
 */
export const buildEmbedPayload = (report, empInfo, biEmpInfo) => {
  // Convert store, district, and region IDs to arrays if they aren't already
  const storeIds = empInfo?.store_id
    ? (Array.isArray(empInfo.store_id) ? empInfo.store_id : [empInfo.store_id])
    : [];

  const districtIds = empInfo?.market_id || empInfo?.district_id
    ? (Array.isArray(empInfo.market_id)
        ? empInfo.market_id
        : Array.isArray(empInfo.district_id)
          ? empInfo.district_id
          : [empInfo.market_id || empInfo.district_id])
    : [];

  const regionIds = empInfo?.region_id
    ? (Array.isArray(empInfo.region_id) ? empInfo.region_id : [empInfo.region_id])
    : [];

  return {
    reportId: report.reportId || report.report_id || report.id,
    datasetId: report.datasetId || report.dataset_id || null,
    userEmail: empInfo?.email || empInfo?.email_work || empInfo?.emp_email || "user@example.com",
    employeeId: empInfo?.employee_id || empInfo?.emp_id || empInfo?.emp_no || null,
    jobTitle: empInfo?.job_title_name || empInfo?.job_title || null,
    jobTitleGroup: empInfo?.group_name || empInfo?.job_group || null,
    storeIds: storeIds,
    districtIds: districtIds,
    regionIds: regionIds,
    companyId: empInfo?.company_id || null,    
    roles: report?.role_code ? (Array.isArray(report.role_code) ? report.role_code : report.role_code.split(',').map(r => r.trim())) : [],
    identity: report.identity
  };
};

/**
 * Get employee info from localStorage
 * @returns {Object} Employee info object
 */
export const getEmployeeInfo = () => {
  return JSON.parse(localStorage.getItem('employee') || '{}');
};

/**
 * Get Power BI employee info from localStorage
 * @returns {Object} Power BI employee info object
 */
export const getPowerBIEmployeeInfo = () => {
  return JSON.parse(localStorage.getItem('powerbi_employee') || '{}');
};

/**
 * Get report icon name
 * @param {Object} report - Report object
 * @returns {string} Icon name
 */
export const getReportIcon = (report) => {
  return report?.report_icon || report?.icon || 'bar-chart';
};
